__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "sid-cp-mfe";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@securitize/reactjs-cp-ui", "0.9.8", function() { return Promise.all([__webpack_require__.e(84), __webpack_require__.e(192), __webpack_require__.e(839), __webpack_require__.e(407), __webpack_require__.e(801), __webpack_require__.e(579), __webpack_require__.e(169)]).then(function() { return function() { return __webpack_require__(87839); }; }); });
			register("axios", "1.2.2", function() { return __webpack_require__.e(159).then(function() { return function() { return __webpack_require__(93159); }; }); });
			register("formik", "2.2.9", function() { return Promise.all([__webpack_require__.e(705), __webpack_require__.e(407)]).then(function() { return function() { return __webpack_require__(55705); }; }); });
			register("history", "4.10.1", function() { return __webpack_require__.e(610).then(function() { return function() { return __webpack_require__(12610); }; }); });
			register("i18n-iso-countries", "7.5.0", function() { return __webpack_require__.e(500).then(function() { return function() { return __webpack_require__(10500); }; }); });
			register("moment", "2.29.4", function() { return __webpack_require__.e(426).then(function() { return function() { return __webpack_require__(72426); }; }); });
			register("react-copy-to-clipboard", "5.1.0", function() { return Promise.all([__webpack_require__.e(407), __webpack_require__.e(29)]).then(function() { return function() { return __webpack_require__(78029); }; }); });
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(407)]).then(function() { return function() { return __webpack_require__(54164); }; }); });
			register("react-query", "3.39.2", function() { return Promise.all([__webpack_require__.e(933), __webpack_require__.e(407), __webpack_require__.e(579)]).then(function() { return function() { return __webpack_require__(91933); }; }); });
			register("react-router-dom", "5.3.4", function() { return Promise.all([__webpack_require__.e(880), __webpack_require__.e(977), __webpack_require__.e(407), __webpack_require__.e(951)]).then(function() { return function() { return __webpack_require__(91523); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(72791); }; }); });
			register("yup", "0.32.11", function() { return Promise.all([__webpack_require__.e(644), __webpack_require__.e(184)]).then(function() { return function() { return __webpack_require__(2644); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};